<template lang="pug">
  .main
    Hero(:content="heroContent")
    .container
      p TEP 誠摯的期盼機構法人及善心人士能慷慨解囊來支持德普文教協會，捐款金額不拘，如願認養一所偏鄉教室，師資培訓、15台電腦、教材、發電機、一整年的薪資及油電費，在新設年度的總成本為 US$10,000，之後維持費用為每年 US$8,000。
      p 所有捐款將全數投入教育，TEP在台灣沒有人事、房租及差旅費用，在柬埔寨不發放救濟金、不建置校舍及其他固定資產，將有限的資源用於購買教學設備，提高師資水準，並以工代賑來協助清寒學生就學。
      h3 資源控管
      ol
        li 收受捐款的銀行專戶由TEP理事長及秘書長兩人共管。
        li 每一筆費用支出都須經TEP理事長及秘書長核可。
        li 捐贈所得、資金及設備物資用途，每季公告於本網站之收支公告上，供捐贈人及使用者查核。
        li 年度結束時，另請會計師查帳後，在本網站上公告查核結果。
      h3 捐贈管道
      TabPanel(:tabs="donateways")
      h3 稅負扣抵
      p 德普文教協會已獲內政部101年5月10日台內社字1010183815號核准設立，得以開立捐款收據，作為扣抵節稅或其他證明之用，敬請捐贈人提供 :  捐款人 (自然人或法人) 名稱、身分證字號或統一編號、聯絡地址。
      h3 收支公告
      p TEP 在年度的3月、6月、9月及12月結束後，公告前3個月的財務季報，明列每一筆捐款收入，並公佈費用支出。

</template>

<script>
import Hero from '@/components/Hero'
import TabPanel from '@/components/TabPanel'

export default {
  components: {
    Hero,
    TabPanel
  },
  data () {
    return {
      heroContent: {
        title: '捐贈訊息。',
        imageNo: 3
      },
      donateways: [
        {
          title: '銀行匯款',
          content: '<p>下列銀行帳戶由TEP理事長及秘書長兩人共管，雙方共同用印方能提款；捐贈人匯款後請以電話或email告知捐款人姓名、身分證字號或統一編號與聯絡地址。</p><p>劉玉婷 電話 0975970261  email ：TaiwanGo@outlook.com<br>侯禮仁 電話 0980824005  email  : houlizen@gmail.com</p>銀行帳戶(新台幣)<br>銀行名稱：國泰世華銀行 安和分行<br>銀行地址 : 台北市安和路2段92號<br>戶名：社團法人德普文教協會<br>銀行代號：013<br>帳號：027-03-500571-0<br>Bank Account (U.S. Dollars)<br>Bank Name：Cathay United Bank,  An-Ho Branch<br>Bank Address：No. 92, Section 2, An-Ho Road, Taipei, Taiwan<br>SWIFT BIC : UWCBTWTP<br>Beneficiary’s Name：TEP Culture and Education Association<br>Account Number：027087025239<br>(自境外匯款至台灣，銀行作業扣款約為每筆US$30~40)'
        },
        {
          title: '支票',
          content: '銀行名稱：國泰世華銀行 安和分行<br>銀行地址 : 台北市安和路2段92號<br>戶名：社團法人德普文教協會<br>銀行代號：013<br>帳號：027-03-500571-0'
        },
        {
          title: '線上捐款',
          content: '請捐款人透過以下網址進行線上捐款，捐款時請留下姓名、身分證字號或統一編號與聯絡地址，以便 TEP 開立捐款收據，作為扣抵節稅或其他證明之用。<br><a href="http://camtw.eoffering.org.tw/">http://camtw.eoffering.org.tw/</a>'
        },
        {
          title: '美國地區捐款',
          content: '請點閱所有捐款管道'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Donate.vue